import { render, staticRenderFns } from "./FixedAssetsList.vue?vue&type=template&id=99c6168e&scoped=true"
import script from "./FixedAssetsList.vue?vue&type=script&lang=js"
export * from "./FixedAssetsList.vue?vue&type=script&lang=js"
import style0 from "./FixedAssetsList.vue?vue&type=style&index=0&id=99c6168e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c6168e",
  null
  
)

export default component.exports